import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { saveTokenToCookie } from '../utils/cookieUtils';

export default function TokenRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      saveTokenToCookie(token);
      navigate('/');
    }
  }, [token, navigate]);

  return null;
}
